<p>profile works!</p>
<div>
  <h2>Athorized user profile data</h2>
  <p>Email address:</p>
  <input [(ngModel)]="email" disabled>
  <p>
  <p>Telegram id:</p>
  <input [(ngModel)]=" telegramid" #ctrl="ngModel" required>
  <p>
    <!--  ALC see https://angular.io/api/forms/NgModel#using-ngmodel-on-a-standalone-control-->
  <p>Valid: {{ ctrl.valid }}</p>
  <p>
  <p></p>
  <p>First Name:</p>
  <input [(ngModel)]="firstNameInput"> <!--type="text" #firstNameInput-->

  <p>Last Name:</p>
  <input  [(ngModel)]="lastNameInput"> <!--type="text" #lastNameInput-->
  <br><br>
  <button (click)="updateAttributes()">Update attributes</button>
  <hr>
  <p>Input telegramid: {{ telegramid }}</p>
  <p>Updated telegramid: {{ updatedTelegramid }}</p>
  <p>Confirmed telegramid: {{ confirmedTelegramid }}</p>
</div>

<!--<ng-template #testingTemplate let-fullName="fullName">
  <div>Full Name (template): {{fullName}}</div>
</ng-template>

<ng-container *ngTemplateOutlet="testingTemplate;context:ctx">
</ng-container>-->
